import styled from 'styled-components';

import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';

export const StyledGrid = styled(Grid)``;

export const HeadlineContainer = styled.div`
  grid-column: 1 / -1;
  padding: 1.6rem 0;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      padding: 4rem 0;
    }
  `}
`;

export const Headline = styled(Typography)``;

export const StyledTwoColumnL20R80 = styled.div`
  height: 100%;
  display: contents;
`;

export const LeftColumn = styled.div`
  height: auto;
  display: none;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
      grid-column: 1 / 4;
    }
  `}
`;

export const RightColumn = styled.div`
  height: auto;
  grid-column: 1 / -1;
  padding-left: 0px;
  border-left: none;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      padding-left: 30px;
      border-left: 1px solid rgb(233, 220, 198);
      grid-column: 4 / -1;
    }
  `}
`;
